// 9fbef606107a605d69c0edbcd8029e5d
import {
  getCurrentPointsState,
  getPointsToNextRewardState,
} from '@tcp/core/src/components/features/account/User/container/User.selectors';
import PlaceCashSelector from '../../../../PlaceCashBanner/container/PlaceCashBanner.selectors';
import { getCartOrderDetails } from '../../../../CartItemTile/container/CartItemTile.selectors';

const getEarnPlaceProximity = (state) => {
  return getCartOrderDetails(state).get('c_earnPlaceProximity') || 0;
};
const getAmountToNextReward = (state) => {
  return (getEarnPlaceProximity(state) || 0).toFixed(2);
};
const getProgressStatus = (state) => {
  const placeCashMin = PlaceCashSelector.getPlaceCashOffer(state);
  return `${
    (((placeCashMin - getEarnPlaceProximity(state)) / placeCashMin) % 1).toFixed(2) * 100 || 0
  }%`;
};

const getEstimatedCartRewards = (state) => {
  return getCartOrderDetails(state).get('estimatedRewards') || 0;
};

const userCurrentTotalPoints = (state) => {
  const currentUserPoints = getCurrentPointsState(state);
  const totalUserPoints = currentUserPoints + getEstimatedCartRewards(state);
  return totalUserPoints || 0;
};

const totalPointsForNextReward = (state) => {
  return getPointsToNextRewardState(state) + getCurrentPointsState(state) || 0;
};

const getPointsToNextReward = (state) => {
  const lpCurrent = userCurrentTotalPoints(state);
  const nextReward = totalPointsForNextReward(state);
  const nextPoints = nextReward - (lpCurrent % nextReward);
  return nextPoints || 0;
};

const getLpProgressStatus = (state) => {
  const lpCurrent = userCurrentTotalPoints(state);
  const nextReward = totalPointsForNextReward(state);
  return `${((lpCurrent / nextReward) % 1).toFixed(2) * 100 || 0}%`;
};

export default {
  getProgressStatus,
  getLpProgressStatus,
  getAmountToNextReward,
  getPointsToNextReward,
  totalPointsForNextReward,
};
